import { render, staticRenderFns } from "./FooterStats.vue?vue&type=template&id=78d2ddca&scoped=true"
import script from "./FooterStats.vue?vue&type=script&lang=js"
export * from "./FooterStats.vue?vue&type=script&lang=js"
import style0 from "./FooterStats.vue?vue&type=style&index=0&id=78d2ddca&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d2ddca",
  null
  
)

export default component.exports